export default "__VITE_PUBLIC_ASSET__87d60c35__"